export const SUBTITLE_ARRAY = [
  'We have let ',
  '$partner',
  ' know that you have cancelled down your finance agreement, and that any work that was planned to be undertaken with this agreement in place should be halted.',
];

export const SUBTITLE_ARRAY_DELIVERY = [
  'We have let ',
  '$partner',
  ' know that you have cancelled down your finance agreement, and that any goods that was planned to be delivered with this agreement in place should be remain undelivered.',
];

export const LINE_2_STANDARD =
  'If you would still like for the work to go ahead without a finance agreement in place, please get in touch with $partner directly and organise an alternate payment method.';

export const LINE_2_DELIVERY =
  'If you would still like for delivery of goods to go ahead without a finance agreement in place, please get in touch with $partner directly and organise an alternate payment method.';
